import { makeAutoObservable } from 'mobx';
import { getProducts, getParcel, getParcels } from 'services/api/Shop';

class ProductStore {
  products = [];
  title  = "";
  categoryName = "";
  message = "";
  isParcels = false;
  isLoading = false;
  isUpdatingCart = false;
  webShopTabId = 2;
  lastSearch = {};
  currentPage = 1;
  itemPerPage = 10;
  itemOrderBy = "alpha_asc";
  productsCount = 0;

  constructor() {
    makeAutoObservable(this);
  }

  clearProducts = () => {
    this.products = {};
    this.productsCount = 0;
  }

  refreshSearch = async (token, options = {}) => {
    return await this.searchProducts(
      token, 
      this.lastSearch["search"], 
      this.lastSearch["sizeFrom"], 
      this.lastSearch["sizeTo"],
      this.lastSearch["color"],
      this.lastSearch["categoryId"],
      options
    );
  }

  searchProducts = async (token, search, sizeFrom="", sizeTo="", color="", categoryId, options = {}) => {
    const { silent = false } = options;

    if (!silent) {
      this.isLoading = true;
    }
    this.title = "";
    this.categoryName = "";
    this.message = null;
    this.isParcels = false;

    this.lastSearch = {
      search: search,
      sizeFrom: sizeFrom,
      sizeTo: sizeTo,
      color: color,
      categoryId: categoryId
    }

    const displayFrom = (this.currentPage - 1) * this.itemPerPage;

    try {
      const data = await getProducts(token, search, sizeFrom, sizeTo, color, categoryId, displayFrom, this.itemPerPage, this.itemOrderBy);
      this.products = data?.content?.products;
      this.productsCount = data?.content?.productsCount;
      this.categoryName = data?.content?.categoryName ? data?.content?.categoryName : "Recherche";
      return data;
    } finally {
      if (!silent) {
        this.isLoading = false;
      }
    }
  }

  storeParcel = (token, parcelId) => {
    this.isLoading = true;
    this.title = "";
    this.categoryName = "";
    this.message = null;
    this.isParcels = true;

    getParcels(token).then(data => {
      const parcel = data.content.find(p => p.id === parcelId);
      this.products = parcel ? [parcel] : null;
      this.isLoading = false;
    })
  }
}

const productStore = new ProductStore();

export default productStore;
